import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAaNnawVNVaay7kUHBFQDlLT_Ms-IoGzOc",
  authDomain: "react-deploy-test-429410.firebaseapp.com",
  projectId: "react-deploy-test-429410",
  storageBucket: "react-deploy-test-429410.firebasestorage.app",
  messagingSenderId: "770320503817",
  appId: "1:770320503817:web:51249d0bfb4b5131cd54d8",
  measurementId: "G-P80Y37VH7K"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Auth
export const auth = getAuth(app);

// Initialize Storage
export const storage = getStorage(app);

// Initialize Functions
export const functions = getFunctions(app);

export default app;
